import { APIKit } from "config/axios/index";
import store from "config/redux/index";
import { start, end } from "config/redux/slice";

import { ServerConstants, ServiceConstants } from "constant";
import { ServiceModel } from "models";
import { Bank, ContractDocumentRequest, UpdateContractDocumentRequest } from "types";

import { handleErrorWithTokenRenewal } from "./common";

const { API_V1_CONTRACT_DOCUMENTS } = ServerConstants;
const {
  REQUEST_CONTRACT_DOCUMENT_LIST_ID,
  REQUEST_CONTRACT_DOCUMENT_OPTIONS_ID,
  REQUEST_CONTRACT_DOCUMENT_CREATE_ID,
  REQUEST_CONTRACT_DOCUMENT_UPDATE_ID,
  REQUEST_CONTRACT_DOCUMENT_DELETE_ID,
} = ServiceConstants;

export async function getContractDocuments(contractId: number) {
  const requestId = REQUEST_CONTRACT_DOCUMENT_LIST_ID + contractId;
  try {
    store.dispatch(start(requestId));
    const response = await APIKit.get(API_V1_CONTRACT_DOCUMENTS, {
      params: { contractId },
    });
    store.dispatch(end(new ServiceModel(requestId, response.data)));
  } catch (err: any) {
    handleErrorWithTokenRenewal(err, getContractDocuments, [contractId], requestId);
  }
}

export async function getContractDocumentOptions(bank: Bank) {
  const requestId = REQUEST_CONTRACT_DOCUMENT_OPTIONS_ID + bank;
  try {
    store.dispatch(start(requestId));
    const response = await APIKit.get(`${API_V1_CONTRACT_DOCUMENTS}/options`, {
      params: { bank },
    });
    store.dispatch(end(new ServiceModel(requestId, response.data)));
  } catch (err: any) {
    handleErrorWithTokenRenewal(err, getContractDocumentOptions, [bank], requestId);
  }
}

export async function createContractDocument(data: ContractDocumentRequest) {
  const requestId = REQUEST_CONTRACT_DOCUMENT_CREATE_ID;
  try {
    store.dispatch(start(requestId));
    const response = await APIKit.post(API_V1_CONTRACT_DOCUMENTS, data);
    store.dispatch(end(new ServiceModel(requestId, response.data)));
  } catch (err: any) {
    handleErrorWithTokenRenewal(err, createContractDocument, [data], requestId);
  }
}

export async function updateContractDocument(id: number, data: UpdateContractDocumentRequest) {
  const requestId = REQUEST_CONTRACT_DOCUMENT_UPDATE_ID;
  try {
    store.dispatch(start(requestId));
    const response = await APIKit.put(`${API_V1_CONTRACT_DOCUMENTS}/${id}`, data);
    store.dispatch(end(new ServiceModel(requestId, response.data)));
  } catch (err: any) {
    handleErrorWithTokenRenewal(err, updateContractDocument, [id, data], requestId);
  }
}

export async function deleteContractDocument(id: number) {
  const requestId = REQUEST_CONTRACT_DOCUMENT_DELETE_ID;
  try {
    store.dispatch(start(requestId));
    const response = await APIKit.delete(`${API_V1_CONTRACT_DOCUMENTS}/${id}`);
    store.dispatch(end(new ServiceModel(requestId, response.data)));
  } catch (err: any) {
    handleErrorWithTokenRenewal(err, deleteContractDocument, [id], requestId);
  }
}
